<div class="frontpage">
  <h1>Välkommen till BuhoBox Light</h1>
    <div class="card">
      <div class="card_text">
       
        <div class="text_info">
          <p>Välkommen till BuhoBox Sociogram, ett digitalt verktyg som ger dig 
            möjlighet att visualisera din grupps relationer.  </p>
            <p>Kom igång genom att läsa in din klass elever och elevernas svar. 
            Resultatet kan sedan presenteras som ett sociogram och ett diagram  </p>
            <p>Detta är en lightversion och BuhoBox betaversion släppas i januari. 
          </p>
        </div>
       
        <div class="text_buttons">
          <h2>Vad vill du göra? </h2>
            <a href="#" routerLink="/read_class"><button>LÄS IN KLASS</button></a><br>
            <a href="#" routerLink="/sociogram"><button>VISA SOCIOGRAM</button></a><br>
            <a href="#" routerLink="/graph"><button>VISA DIAGRAM</button></a>
        </div>

      </div>
      <div class="card_img"><img src="../assets/img/buhobox_on_home.png" alt=""></div>
    </div>
</div>

  
<div class="footer">
  <h3><b>Kontakta oss för mer information</b></h3>
  <a href="mailto:sara.lindahl@ineqsolutions.se"><button>KONTAKTA OSS</button></a>
</div>
